module.exports = __webpack_public_path__ + "media/images/flags/pw-19b39106bc694a7e4ccf0458fa08b328.svg";